import React, {useState } from "react";
import { Modal } from "react-bootstrap";
import ButtonComponent from "../components/ButtonComponent";
import theme from "../theme/theme";
import { resetPasswordAsync } from "../services/employeeService";
import { useNavigate } from "react-router-dom";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [idNumber, setIdNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [emailLocalPart, setEmailLocalPart] = useState("");
  const [notFoundRes, setNotFoundRes] = useState("");


  const EMAIL_DOMAIN = "@oc.edu.sa";
  
  
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const fullEmail = `${emailLocalPart}@oc.edu.sa`;
  
    if (!fullEmail.endsWith("@oc.edu.sa")) {
      alert("الإيميل يجب أن ينتهي بـ @oc.edu.sa");
      return;
    }
  
    setIsLoading(true);
    setNotFoundRes("");
    try {
      await resetPasswordAsync({ idNumber: idNumber.trim(), email: fullEmail });
      setResponseMessage("تم إرسال كلمة مرور جديدة إلى بريدك الإلكتروني.");
      setSuccessModal(true);
      clearInputs();
    } catch (error) {
      const status = error.response?.status;
      if (status === 404) setNotFoundRes("البيانات غير متطابقة، الرجاء التأكد من رقم الهوية والبريد الإلكتروني.");
      else if (status === 403) setNotFoundRes("الحساب غير نشط، الرجاء التواصل مع الدعم الفني.");
      else setNotFoundRes("تعذر إرسال البريد الإلكتروني، حاول لاحقاً.");
    } finally {
      setIsLoading(false);
    }
  };
  
const clearInputs=()=>{
      setEmailLocalPart("")
      setIdNumber("")
}
 
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ padding: "20px" }}
    >
      <div
        className="form-container text-center"
        style={{ maxWidth: "600px", width: "100%" }}
      >
        <h2>إعادة تعيين كلمة المرور</h2>
        <div>
          <p className="text-muted mb-0">
            عند اعادة تعيين كلمة المرور 
          </p>
          <p className="text-muted mb-0">
            سوف يتم ارسال كلمة مرور جديدة على الايميل المنتهي ب 
            <span> oc.edu.sa@ </span>
            فقط.
          </p>
          <div className="text-muted mb-4">
            <span className="fw-bold">ملاحظة : </span>
            <span>يمكنك تحديث كلمة المرور في حسابك الشخصي بعد تسجيل الدخول</span>
          </div>
        </div>
        {notFoundRes && <div className="alert alert-danger">
          <p className="fw-bold">
            {notFoundRes}
          </p>
          <p>في حال واجهتك مشكلة الرجاء مراجعة مركز المعلومات والاحصاء </p>
          <p>او مراسلة فريق الدعم الفني : 
             <a href="mailto:support@mg.rasedbank.com" className="text-primary fw-semibold">
    support@mg.rasedbank.com
  </a>
          </p>
          </div>
          }
        <form
          autoComplete="off"
          style={{ overflow: "hidden" }}
          className="d-flex flex-column justify-content-center align-items-center p-4"
          onSubmit={handleSubmit}
        >
          <div className="form-group w-100 mb-3">
            <input
              type="text"
              required
              value={idNumber}
              onChange={(e) => setIdNumber(e.target.value)}
              className="form-control"
              placeholder="رقم الهوية"
              autoComplete="off"
            />
          </div>
          <div className="form-group w-100 mb-3 d-flex align-items-center">
  {/* Domain part (readonly) */}
 
 
  <span
    className="form-control bg-light"
    style={{
      width: "140px",
       textAlign: "center",
      lineHeight: "38px",
       border:'none'
    }}
  >
    oc.edu.sa@
  </span>
  {/* Local part input */}
  <input
    type="text"
    required
    value={emailLocalPart}
    onChange={(e) => {
      const input = e.target.value;
      if (!input.includes("@")) {
        setEmailLocalPart(input);
      }
    }}
    className="form-control"
    placeholder="ادخل اسم البريد"
    autoComplete="off"
    style={{ flex: 1 }}
    />
   
    </div>
 

          <button
            type="submit"
            className="button-md primary-bg primary-hover col-12 mt-4"
            disabled={isLoading}
          >
            {isLoading ? <Spinner /> : "تحديث"}
          </button>
          <button
            type="button"
            className="mt-4 button-md primary-outline-bg primary-hover col-12"
            onClick={() => navigate("/login-page")}
          >
            رجوع الى تسجيل الدخول
          </button>
        </form>
      </div>

      <Modal
        show={successModal}
        onHide={() => setSuccessModal(false)}
        centered
        dialogClassName="custom-modal"
      >
        <Modal.Header>
          <Modal.Title className="ms-3">تمت إعادة تعيين كلمة المرور.</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <Modal.Body>
            <p>{responseMessage}</p>
            <p className="secondary-color fw-bold">في حال لم تصلك كلمة المرور الرجاء مراجعة مركز المعلومات .</p>
          </Modal.Body>
          <ButtonComponent
            text="إغلاق"
            className="primary-bg"
            onClick={() => setSuccessModal(false)}
          />
        </Modal.Footer>
      </Modal>
    </div>
  );
};

const Spinner = () => (
  <div
    className="spinner"
    style={{
      border: `4px solid ${theme.colors.light}`,
      borderLeftColor: theme.colors.secondary,
      borderRadius: "50%",
      width: "24px",
      height: "24px",
      margin: "auto",
      animation: "spin 1s linear infinite",
    }}
  ></div>
);

export default ResetPassword;
